import { RouteConfig } from 'vue-router';
const Folder = () => import('./views/folder.vue');
const ShaichaList = () => import('./views/shaicha-list.vue');
const routers: RouteConfig[] = [
    {
        path: 'folder',
        name: 'folder',
        component: Folder
    },
    {
        path: 'shaicha-list',
        name: 'shaicha-list',
        component: ShaichaList
    },
    {
        path: '',
        redirect: 'folder'
    },
];
export default routers;

